import { Module } from 'shared/services/prisma/types';
import { MODULE_PATH } from 'shared/constants/survey';
import { EDIT_DATA_SOURCE } from 'shared/constants/permissions';
import DataSourceDashboard from './DataSourceDashboard';
import Analytics from './Analytics/Analytics';
import Surveys from './Survey/Surveys';
import Hsr from './Hsr/Hsr';
import DataSourceSettings from './Settings/DataSourceSettings';

const routes = [
  {
    path: 'dashboard',
    component: DataSourceDashboard,
    exact: true,
    label: 'Overview',
  },
  {
    path: 'analytics',
    component: Analytics,
    module: Module.Analytics,
  },
  {
    path: 'hsr',
    component: Hsr,
    module: Module.Heatmaps,
  },
  {
    path: MODULE_PATH[Module.UxSurveys],
    component: Surveys,
    module: Module.UxSurveys,
  },
  {
    path: MODULE_PATH[Module.CxSurveys],
    component: Surveys,
    module: Module.CxSurveys,
  },
  {
    path: 'settings',
    component: DataSourceSettings,
    dataSourcePermission: EDIT_DATA_SOURCE,
  },
];

export default routes;
